<template>
  <b-sidebar
    id="add-new-booking-sidebar"
    :visible="isAddNewBookingSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-booking-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="
          d-flex
          justify-content-between
          align-items-center
          content-sidebar-header
          px-2
          py-1
        "
      >
        <h5 class="mb-0">Edit Booking</h5>
        <div>
          <feather-icon
              class="ml-1 cursor-pointer"
              icon="SaveIcon"
              size="18"
              style="color:green"
              @click="onSubmit"
            />
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
        </div>
      </div>
       <b-overlay
          :show="loading"
          spinner-variant="primary"
          spinner-type="grow"
          spinner-small
          rounded="sm"
        >
      <!-- Body -->
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <b-form-group
            class=""
            label="Booking Stage"
            label-for="booking_stage_id"
          >
            <v-select
              v-model="bookingData.booking_stage_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="bookingstageOptions"
              label="stage"
              :reduce="(option) => option.id"
              :clearable="true"
            >
              <template #option="{ stage, background_color }">
                <div
                  class="rounded-circle d-inline-block mr-50 bg-primary"
                  :style="{
                    background: background_color + ' !important',
                    height: '10px',
                    width: '10px',
                  }"
                />
                <span> {{ stage }}</span>
              </template>

              <template #selected-option="{ stage, background_color }">
                <div
                  class="rounded-circle d-inline-block mr-50 bg-primary"
                  :style="{
                    background: background_color + ' !important',
                    height: '10px',
                    width: '10px',
                  }"
                />
                <span> {{ stage }}</span>
              </template>
            </v-select>
          </b-form-group>
          <b-form-group class=""
            label="Customer"
            label-for="customer_id">
            <v-select
              v-model="bookingData.customer_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="customerOptions"
              label="name"
              :reduce="(option) => option.id"
              :clearable="true"
              @input="changeCustomer"
            >
            <template #option="{ name, id }">
               [{{ id }}] {{ name }}
            </template>

            <template #selected-option="{ name, id }">
               [{{ id }}] {{ name }}
            </template>
            </v-select>
          </b-form-group>
          <b-form-group class=""
            label="Coach"
            label-for="coach_id">
            <v-select
              v-model="bookingData.coach_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="coachOptions"
              label="coach_name"
              :reduce="(option) => option.id"
              :clearable="true"
            
            />
          </b-form-group>

          <b-form-group class=""
            label="Vehicle Type"
            label-for="vehicle_type_id">
            <v-select
              v-model="bookingData.vehicle_type_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="vehicleTypeOptions"
              label="vehicle_type_name"
              :reduce="(option) => option.id"
              :clearable="true"
            />
          </b-form-group>
          <b-form-group class=""
            label="Learning Type"
            label-for="learning_type_id">
            <v-select
              v-model="bookingData.learning_type_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="learningTypeOptions"
              label="type_name"
              :reduce="(option) => option.id"
              :clearable="true"
            />
          </b-form-group>
          <b-form-group class=""
            label="考試路線"
            label-for="driving_center_id">
            <v-select
              v-model="bookingData.driving_center_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="drivingCenterOptions"
              label="route_name"
              :reduce="(option) => option.id"
              :clearable="true"
            />
          </b-form-group>
          <b-form-group label="Pick Up Address" label-for="pick_up_address">
          <b-form-input
                id="pick_up_address"
                v-model="bookingData.pick_up_address"
                autofocus
                trim
                placeholder=""
              >
              </b-form-input>
          </b-form-group>
          <validation-provider
            #default="validationContext"
            name="上堂時間"
            rules="required"
          >
          <b-form-group
            label="上堂時間"
            label-for="date_of_birth"
          >
            <flat-pickr
              class="form-control"
              v-model="bookingData.lesson_time"
              style="background: white"
              :config="{ enableTime: true,dateFormat: 'Y-m-d H:i'}"
            />
            <b-form-invalid-feedback :state="getValidationState(validationContext)">
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <b-form-group label="上堂節數" label-for="number_of_lesson">
          <b-form-input
                id="number_of_lesson"
                v-model="bookingData.number_of_lesson"
                autofocus
                trim
                placeholder=""
              >
              </b-form-input>
          </b-form-group>

          <b-form-group label="每節時間(分鐘)" label-for="minute_per_lesson">
          <b-form-input
                id="minute_per_lesson"
                v-model="bookingData.minute_per_lesson"
                autofocus
                trim
                placeholder=""
              >
              </b-form-input>
          </b-form-group>


      
          
          <!-- Description -->
          <b-form-group label="Remark" label-for="remark">
            <quill-editor
                  id="quil-content"
                  v-model="bookingData.remark"
                  :options="editorOption"
                  class="border-bottom-0"
                />
                <div
                  id="quill-toolbar-booking"
                  class="d-flex justify-content-end border-top-0"
                >
                  <!-- Add a bold button -->
                  <button class="ql-bold" />
                  <button class="ql-italic" />
                  <button class="ql-underline" />
                  <button class="ql-align" />
                  <button class="ql-link" />
                </div>
          </b-form-group>
          
          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              Save
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
       </b-overlay>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BFormTextarea,
  BOverlay,
  BFormDatepicker,
  BFormCheckbox
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { ref, watch } from "@vue/composition-api";
import { required, alphaNum, email } from "@validations";
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";

import { useToast } from "vue-toastification/composition";

import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    BFormTextarea,
    BOverlay,
    BFormDatepicker,
    BFormCheckbox,
    quillEditor,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    flatPickr
  },
  directives: {
    Ripple,
  },
  model: {
    prop: "isAddNewBookingSidebarActive",
    event: "update:is-add-new-booking-sidebar-active",
  },
  props: {
    isAddNewBookingSidebarActive: {
      type: Boolean,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    bookingstageOptions: {
      type: Array,
      required: true,
    },
    coachOptions: {
      type: Array,
      required: true,
    },
    vehicleTypeOptions: {
      type: Array,
      required: true,
    },
    learningTypeOptions: {
      type: Array,
      required: true,
    },
    customerOptions:{
      type: Array,
      required: true
    },
    drivingCenterOptions:{
      type: Array,
      required: true,
    }    
  },
  data() {
    return {
      required,
      alphaNum,
      email,
    };
  },
  computed:{
    coach_id(){
      return this.bookingData.coach_id
    }
  },
  watch:{
    coach_id(newCoach_id, oldCoach_id)
    {
      if(newCoach_id){
        let coach = this.coachOptions.find(coach => coach.id == newCoach_id)
        this.bookingData.minute_per_lesson = coach.learning_time_per_lesson
        this.bookingData.pick_up_address = coach.pick_up_address
      }
      
    }
  },

  methods: {
    changeCustomer(){
      let customer = this.customerOptions.find(customer => customer.id == this.bookingData.customer_id)
      this.bookingData.vehicle_type_id = customer.vehicle_type_id
      this.bookingData.coach_id = customer.coach_id
      this.bookingData.driving_center_id = customer.driving_center_id
      this.bookingData.learning_type_id = customer.learning_type_id
    },
    hide() {
      this.isAddNewBookingSidebarActive = false;
    },
    onSubmit() {
      this.$swal({
        title: "Are you sure?",
        text: "",
        showCancelButton: true,
        confirmButtonText: "Save",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          this.$store
            .dispatch("booking/updateBooking", this.bookingData)
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.loading = false;
              this.hide();
              this.$emit("refetch-data");
              this.$emit("refetch-statistic");
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  setup(props, { emit }) {
    const blankBookingData = {
      id: 0,
      customer_id: null,
      coach_id: null,
      driving_center_id: null,
      learning_type_id: null,
      vehicle_type_id: null,
      pick_up_address: '',
      lesson_time: null,
      number_of_lesson: 2,
      minute_per_lesson: 45,
      remark: '',
      booking_stage_id: null,
    };

    const bookingData = ref(JSON.parse(JSON.stringify(blankBookingData)));
    const resetbookingData = () => {
      bookingData.value = JSON.parse(JSON.stringify(blankBookingData));
    };

    const toast = useToast();
    const loading = ref(false);

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetbookingData);

    watch(
      () => [props.id, props.isAddNewBookingSidebarActive],
      () => {
        if (props.id > 0 && props.isAddNewBookingSidebarActive) {
          bookingData.value = {...props.data}
        } else {
        }
      }
    );
    const editorOption = {
      modules: {
        toolbar: "#quill-toolbar-booking",
      },
      placeholder: "remark",
    };

    return {
      bookingData,
      loading,
      refFormObserver,
      getValidationState,
      resetForm,
      editorOption,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import '@core/scss/vue/libs/vue-flatpicker.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>